module.exports = __webpack_public_path__ + "images/static/media/virgin-router.png";